import { Component } from "@angular/core";
import {
  SwUpdate,
  UnrecoverableStateEvent,
  VersionEvent,
} from "@angular/service-worker";
import { AlertService } from "./core/alerts/alerts.service";

import { swLog } from "#/log";
import { AnalyticsService } from "./core/analytics/analytics.service";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  constructor(
    protected swUpdate: SwUpdate,
    protected alert: AlertService,
    protected analytics: AnalyticsService,
  ) {
    this.swUpdate.unrecoverable.subscribe(this.onSwUnrecoverable.bind(this));
    this.swUpdate.versionUpdates.subscribe(this.onSwVersionUpdate.bind(this));
  }

  protected onSwVersionUpdate(evt: VersionEvent) {
    this.analytics.trackSwVersionEvent(evt);
    switch (evt.type) {
      case "VERSION_DETECTED":
        swLog.info(
          `Downloading new app version: ${evt.version.hash}. App data:`,
          evt.version.appData,
        );
        break;
      case "VERSION_READY":
        swLog.info(
          `Current app version: ${evt.currentVersion.hash}. App data:`,
          evt.currentVersion.appData,
        );
        swLog.info(
          `New app version ready for use: ${evt.latestVersion.hash}. App data:`,
          evt.latestVersion.appData,
        );
        break;
      case "VERSION_INSTALLATION_FAILED":
        swLog.warn(
          `Failed to install app version '${evt.version.hash}': ${evt.error}. App data:`,
          evt.version.appData,
        );
        break;
    }
  }

  protected async onSwUnrecoverable(
    event: UnrecoverableStateEvent,
  ): Promise<void> {
    this.analytics.trackSwUnrecoverable(event);
    swLog.error(`Service worker unrecoverable error:`, event.reason);
    const confirmed = await this.alert.showConfirmAlert("about", [
      "An internal app error occurred that requires reloading:\n" +
        event.reason +
        "\n\nReload now?",
    ]);
    if (confirmed) {
      document.location.reload();
    }
  }
}
